export const commonHomeFieldKeysMap = new Map([
    ['timezone', 'Timezone'],
    ['location', 'Location'],
]);

export const energyHomeFieldKeysMap = new Map([
    ['heating_priority', 'Heating priority'],
    ['heating_energy', 'Heating energy'],
    ['heating_type', 'Heating type'],
    ['home_type', 'Home type'],
    ['home_size', 'Home size'],
    ['open_window_detection', 'Open Window Detection'],
]);

export const securityHomeFieldKeysMap = new Map([
    ['gone_after', 'Gone after'],
    ['share_info', 'Share info'],
    ['smart_notifs', 'Smart Notifs'],
    ['events_ttl', 'Delete old events'],
    ['notify_from', 'Notify from'],
    ['notify_to', 'Notify to'],
    ['enable_notify_from_to', 'Notify Activated'],
    ['record_movements', 'Record other motions'],
    ['notify_movements', 'Notify other motions'],
    ['record_alarms', 'Record & Notify alarms'],
    ['record_animals', 'Record animals' ],
    ['notify_animals', 'Notify animals'],
    ['record_humans', 'Record people'],
    ['notify_humans', 'Notify people'],
    ['record_vehicles', 'Record cars'],
    ['notify_vehicles', 'Notify cars'],
    ['notify_unknowns', 'Notify unknowns'],
    ['siren_sound_unknowns', 'Sound unknowns'],
    ['siren_sound_humans', 'Sound people'],
    ['siren_sound_movements', 'Sound other motions'],
    ['siren_sound_animals', 'Sound animals'],
]);
